import { render } from "./UserProfileManagement.vue?vue&type=template&id=4fa3f2d2&ts=true"
import script from "./UserProfileManagement.ts?vue&type=script&lang=ts&external"
export * from "./UserProfileManagement.ts?vue&type=script&lang=ts&external"

import "./UserProfileManagement.scss?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__